module.exports = __webpack_public_path__ + "img/celular.56db96c2.svg";